import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-24" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_3 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "flex items-center content-center" }
const _hoisted_6 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-b-lg" }
const _hoisted_7 = { class: "flex items-center flex-col gap-2 my-2" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "font-bold break-all leading-tight text-2xl mt-0 mr-2" }, "New FAQ Entry", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.create())),
              class: "text-sm cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white ml-3"
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("span", null, "SAVE", -1)
            ]))]),
            _createElementVNode("span", {
              onClick: [
                _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args)), ["prevent"])),
                _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeAdd && _ctx.closeAdd(...args)))
              ],
              class: "cursor-pointer rounded-md text-white py-2 pl-2 hover:opacity-70"
            }, "CLOSE")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass('input-wrapper ' + (_ctx.form.question.error_type))
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-xs tracking-[0.4px]" }, "Question", -1)),
              _withDirectives(_createElementVNode("input", {
                placeholder: "Input Your Question Here",
                onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['question']))),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.question.value) = $event)),
                class: "block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm",
                type: "text"
              }, null, 544), [
                [_vModelText, _ctx.form.question.value]
              ]),
              (_ctx.form.question.error_message)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "field-error label-text mt-1",
                    textContent: _toDisplayString(_ctx.form.question.error_message)
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass('input-wrapper ' + (_ctx.form.answer.error_type))
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-xs tracking-[0.4px]" }, "Answer", -1)),
              _withDirectives(_createElementVNode("textarea", {
                placeholder: "Input Your Answer Here",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.answer.value) = $event)),
                onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateFields(['answer']))),
                class: "block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm"
              }, null, 544), [
                [_vModelText, _ctx.form.answer.value]
              ]),
              (_ctx.form.answer.error_message)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "field-error label-text mt-1",
                    textContent: _toDisplayString(_ctx.form.answer.error_message)
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}